import React from 'react';
import './TopProgressBar.css';

const TopProgressBar = () => {
  return <div className="top-progress-bar"></div>;
};

export default TopProgressBar;
